import { FC } from 'react';
import SpriteIcon from '../shared/sprite-icon';
import OWLink from '../shared/ow-link';

// -----------------------------------------------------------------------------
interface Props {
  path: string;
  text: string;
  hasNext: boolean;
}

// -----------------------------------------------------------------------------
const Caret = (): JSX.Element => {
  return (
    <svg>
      <SpriteIcon icon='caret' />
    </svg>
  );
};

// -----------------------------------------------------------------------------
export const BreadCrumbItem: FC<Props> = ({
  path,
  text,
  hasNext,
}): JSX.Element => {
  return (
    <li>
      <OWLink href={path}>
        {text}
        {hasNext && <Caret />}
      </OWLink>
    </li>
  );
};
